const initialState = {
  type: null,
  message: null,
}

export default function error(state = initialState, action) {
  switch (action.type) {
    case "SET_ERROR": {
      action.payload.type === "access_denied" &&
        window.appendFlash(
          decodeURIComponent(action.payload.message.replace(/\+/g, " ")),
          "danger"
        )

      return {
        ...state,
        type: action.payload.type,
        message: action.payload.message,
      }
    }

    default: {
      return state
    }
  }
}
